import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import mixpanel from "mixpanel-browser";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_GET_OPPORTUNITY_DETAILS } from "../../../config/api";

export const getOpportunityDetails = createAsyncThunk(
  "opportunities/getDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_GET_OPPORTUNITY_DETAILS.replace("{id}", id),
      });

      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {
      //   type: "opportunities",
      //   subtype: "get-opportunities-details",
      //   message: msg,
      // });
      // toast.error(msg);
      throw error;
    }
  }
);
